import { DataGrid } from "@mui/x-data-grid";
import {
  fKeyTabInput,
  hasValueInErrorMessage,
} from "../../../Utility/Utilitys";
import {
  
  CmpCheckboxField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";

import Grid from "@mui/material/Grid";

import { sTax } from "../WmsSalesInvoiceAction";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
 
export default function GCHead({
  fOpenERPStockModal,
  xItemStock,
  xposMode,
  vRdxWmsInvoiceHead,
  vRdxuserLoc,
  DocLoading,
  currency,
  selecType,
  fOpenHeadCustomerSearchModalKey,
  sPayModeArr,
  fOnChangeSelectDocType,
  fOnChangeSelectCurr,
  fOnChangeInputDate,
  fOnChangeInputDateRefDate,
  fonChangeInput,
  fonChangeInputTaxType,
  fonChangeInputInvType,
  fonChangeInputPayMode,
  fonChangeInputTaxable,
  fonChangeInputPosMode,
  fonChangeInputLocation,
  fonChangeInputCustomer,
  sInstTypeArr,
  sErrorMsg,
  sDetailGridData,
  sToggleGrid,
  GridDataSalesHistoryColumns,
  sGridSalesHistoryRowData,
  vMediaQuery,

  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  inputReference,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
  xPaymodeEnable,
  xOsAmount = "",
}) {
  return (
    <div className="Wms-sales-invoice-head">
      <Grid
        container
        rowSpacing={0.9 }
        columnSpacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={6} sm={6} md={4}  >
                <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsInvoiceHead.A_VocTyp}
                xOnChange={(e) => {
                  fOnChangeSelectDocType(e);
                }}
                xName={"A_VocTyp"}
                xData={DocLoading}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocTyp}
                xDisable={sDetailGridData.length > 0 || vRdxWmsInvoiceHead.A_VocNo !=0}
                // xOnKeyUp={xKey}
              />
            </Grid>
 
            <Grid item xs={6} sm={6} md={4}  >
           <CmpTextFieldV1
                          xLabelText="Doc.No"
                xValue={vRdxWmsInvoiceHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocNo}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>

           
            <Grid item xs={6} sm={6} md={4}  >
               <CmpDatePickerField001V1
                              xLabelText="Doc.Date"
                xtabIndex={"2"}
                xref={inputReference}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsInvoiceHead.A_PostDt}
                xOnChange={fOnChangeInputDate}
                xName={"A_PostDt"}
                xError={sErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
           
            <Grid item xs={6} sm={6} md={4} lg={4}>
               <CmpTextFieldV1
                xLabelText="Ref.No"
                xValue={vRdxWmsInvoiceHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInput(e);
                }}
                xError={sErrorMsg.A_RefNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefNo}
                // xOnKeyUp={xKey}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4}>
             <CmpDatePickerField001V1
                xLabelText="Ref.Date"
                xValue={vRdxWmsInvoiceHead.A_RefDt}
                xOnChange={(e) => {
                  fOnChangeInputDateRefDate(e);
                }}
                xName={"A_RefDt"}
                xError={sErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
        
            <Grid item xs={6} sm={6} md={4}>
              <CmpSelectArrFieldV1
                xLabelText="Inv.Type"
                xValue={vRdxWmsInvoiceHead.A_INV_TYPE}
                xOnChange={(e) => {
                  fonChangeInputInvType(e);
                }}
                xName={"A_INV_TYPE"}
                xData={sInstTypeArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_INV_TYPE === "" ? false : true}
                xErrorMessage={sErrorMsg.A_INV_TYPE}
                xDisable={sDetailGridData.length > 0}
                xtabIndex={"4"}
              />
            </Grid>
           
              
              <Grid item xs={6} sm={4} md={4} lg={4}>
                <CmpSelectArrFieldV1
                  xLabelText="Paymode"
                  xValue={vRdxWmsInvoiceHead.A_PayMode}
                  xOnChange={(e) => {
                    fonChangeInputPayMode(e);
                  }}
                  xName={"A_PayMode"}
                  xData={sPayModeArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_PayMode === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_PayMode}
                  xDisable={false}
                />
              </Grid>
              
              <Grid item xs={6} sm={4} md={4} lg={4}>
                <CmpSelectFieldV1
                  xLabelText="Currency"
                  xValue={vRdxWmsInvoiceHead.A_Curr}
                  xOnChange={fOnChangeSelectCurr}
                  xName={"A_Curr"}
                  xData={currency}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Curr === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Curr}
                  xDisable={sDetailGridData.length > 0}
                  // xDisable={true}
                />
              </Grid>
              
              <Grid item xs={6} sm={4} md={4} lg={4}>
              <CmpTextFieldV1
                  xLabelText="ExRate"
                  xValue={vRdxWmsInvoiceHead.A_ExRate}
                  xType={"number"} // text/number/password
                  xName={"A_ExRate"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                  // xOnKeyUp={(e) => {
                  //   xFocusInput("A_LocName");
                  // }}
                />
              </Grid>
            <Grid item xs={4} sm={4} md={2} className=" p-left-label ">
              <span
                className={
                  vRdxWmsInvoiceHead.A_DocStat == "ENTER"
                    ? "txt-overflow-wms "
                    : "hide-content"
                }
                title={xItemStock?.rpStock}
                onClick={fOpenERPStockModal}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"ERP: " + xItemStock?.rpStock}
                />{" "}
              </span>
            </Grid>
            <Grid item xs={4} sm={4} md={2}>
              <span
                className={
                  vRdxWmsInvoiceHead.A_DocStat == "ENTER"
                    ? "txt-overflow-wms"
                    : "hide-content"
                }
                title={xItemStock?.wmsStock}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"WMS: " + xItemStock?.wmsStock}
                />{" "}
              </span>
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <span
                className={
                  vRdxWmsInvoiceHead.A_DocStat == "ENTER"
                    ? "txt-overflow-wms"
                    : "hide-content"
                }
                title={xItemStock?.OpenBinStock}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"OpenStock: " + xItemStock?.OpenBinStock}
                />{" "}
              </span>
            </Grid>
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 170, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  // onRowClick={fonRowClickGridObj}
                  hideFooter={sGridSalesHistoryRowData.length < 100}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={0.9}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(sErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
           
             
            
              <Grid item xs={12} sm={12} md={12} lg={10}>
                <Grid container spacing={0.9}>
                {!vMediaQuery && (  <Grid item xs={3} sm={2} md={2} lg={2}>
                    <CmpTextFieldV1
                        xLabelText="Customer"
                      xValue={vRdxWmsInvoiceHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsg.A_Party === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_Party}
                    />
                  </Grid>)}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={10}
                    lg={10}
                    className="dropDowntoggle"
                  >
                      <GCToggleSearchV1
                      xLabelText="Customer Name"
                      xName={"A_PartyName"}
                      xType={"text"}
                      xValue={vRdxWmsInvoiceHead.A_PartyName}
                      xReadOnly={false}
                      xOnChange={(e) => {
                        fonChangeInputCustomer(e);
                      }} //GCToggleSearch onchange main input
                      xOnKeyUp={(e) => {
                        fOpenHeadCustomerSearchModalKey(e, "customer");
                      }} //GCToggleSearch xOnKeyUp main input
                      xError={sErrorMsg.A_PartyName === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_PartyName}
                      xMediaQuery={false}
                      xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                      xrows={xrowDropdownSearch} //GCToggleSearch-grid
                      xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                      xRowCellClick={xOnCellKeyDown}
                      xRowClick={xOnRowClick}
                      xToggle={xToggleDropdown} //GCToggleSearch- true/false
                      xData={xData} //GCToggleSearch-select
                      xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                      xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                      xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                      xtabIndex="5"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={4} md={4} lg={4}>
                 <CmpSelectFieldV1
                  xLabelText="Location"
                  xValue={vRdxWmsInvoiceHead.A_Loc}
                  xOnChange={(e) => {
                    fonChangeInputLocation(e);
                  }}
                  xName={"A_Loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Loc === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Loc}
                  xDisable={sDetailGridData.length > 0}
                />
              </Grid>
              

             
              <Grid item xs={6} sm={3} md={3} lg={3}>
               <CmpSelectFieldV1
                  xLabelText="Tax Type"
                  xValue={vRdxWmsInvoiceHead?.A_CUSTFIELD3}
                  xOnChange={(e) => {
                    fonChangeInputTaxType(e);
                  }}
                  xName={"A_CUSTFIELD3"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_CUSTFIELD3 === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_CUSTFIELD3}
                  // xDisable={sDetailGridData.length > 0} client
                  xDisable={true}
                />
              </Grid>
 
              <Grid item xs={6} sm={3} md={2.5} lg={2.5}>
                <CmpSelectArrFieldV1
                  xLabelText="Type"
                  xValue={vRdxWmsInvoiceHead.A_Type}
                  xOnChange={(e) => {
                    fonChangeInput(e);
                  }}
                  xName={"A_Type"}
                  xData={selecType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Type === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Type}
                  xDisable={sDetailGridData.length > 0}
                  xtabIndex={"6"}
                />
              </Grid>

              <Grid item xs={6} sm={2} md={1} lg={1}>
                <CmpCheckboxField
                  xChecked={vRdxWmsInvoiceHead.A_Taxable == "Y"}
                  xOnChange={fonChangeInputTaxable}
                  xDisabled={true}
                  xName={"A_Taxable"}
                  xNameField={"Tax"}
                  xError={sErrorMsg.A_Taxable === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Taxable}
                />
              </Grid>
            
              <Grid item xs={6} sm={4} md={1.2} lg={1.2}>
                <CmpCheckboxField
                  xChecked={xposMode}
                  xOnChange={fonChangeInputPosMode}
                  xDisabled={false}
                  xName={"PosMode"}
                  xNameField={"Pos Mode"}
                  xError={false}
                  xErrorMessage={""}
                />
              </Grid>
              {vRdxWmsInvoiceHead.A_DocStat === "ENTER" ? (
                <>
                  
                  <Grid item xs={6} sm={4} md={3} lg={3}>
                    <CmpTextFieldV1
                  xLabelText="Net O/s Amt"
                      xValue={xOsAmount.NetOsAmt}
                      xType={"text"} // text/number/password
                      xName={"NetAmtWithoutPDC"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>
                
                  <Grid item xs={6} sm={4} md={3} lg={3}>
                   <CmpTextFieldV1
                  xLabelText="PDC Amt"
                      xValue={xOsAmount.PDCAmt}
                      xType={"text"} // text/number/password
                      xName={"PDCAmt"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>
                  
                  <Grid item xs={6} sm={4} md={2} lg={2}>
                    <CmpTextFieldV1
                  xLabelText="Balance O/s Amt"
                      xValue={xOsAmount.BalanceOsAmt}
                      xType={"text"} // text/number/password
                      xName={"BalanceOsAmt"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={false}
                      xErrorMessage={""}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}

               
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
